import { render, staticRenderFns } from "./Importacoes.vue?vue&type=template&id=3a51fcd4&scoped=true&"
import script from "./Importacoes.vue?vue&type=script&lang=js&"
export * from "./Importacoes.vue?vue&type=script&lang=js&"
import style0 from "./Importacoes.vue?vue&type=style&index=0&id=3a51fcd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51fcd4",
  null
  
)

export default component.exports